<template>

    <section class="w-100 h-100">

        <!-- Manage Data List -->
        <div class="d-flex flex-column w-100 h-100">

            <h2 class="order-1">Manage Data</h2>

            <!-- Check Manage Data List -->
            <template v-if="Object.values(alldata).length > 0">

                <!-- Page List Render-->
                <table-element :classname="['table-striped', 'order-2', 'my-3']">

                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">Total Posts Active </th>
                            <th scope="col">Total Posts Inactive </th>
                            <th scope="col">Posts Active {{ currentYear }}</th>
                            <th scope="col">Posts Inactive {{ currentYear }}</th>
                            <th scope="col">Contacts</th>
                            <th scope="col">Workwithus</th>
                            <th scope="col">Users</th>
                            <th scope="col">Pages Active</th>
                            <th scope="col">Pages Inactive</th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>

                        <tr>
                            <td>{{ alldata.total_posts_active_allyears }}</td>
                            <td>{{ alldata.total_posts_inactive_allyears }}</td>
                            <td>{{ alldata.total_posts_active }}</td>
                            <td>{{ alldata.total_posts_inactive }}</td>
                            <td>{{ alldata.total_contacts }}</td>
                            <td>{{ alldata.total_workwithus }}</td>
                            <td>{{ alldata.total_users }}</td>
                            <td>{{ alldata.total_pages_active }}</td>
                            <td>{{ alldata.total_pages_inactive }}</td>
                        </tr>

                    </template>

                </table-element>

            </template>

            <template v-else>

                <span>No Data to show</span>

            </template>
        
        </div>

    </section>

</template>
<script>
import Table from './../elements/TableElement.vue';

//Set Use Strict
"use strict";

    export default{
        name: "HomeComponent",
        props:{
            allmedia:{
                type: String,
                required: true
            },
            logotipomedia:{
                type: String,
                required: true
            },
            managealldata:{
                type: String,
                required: true
            }
        },
        data: () => {

            return{

                mediafileslocalstorage: {},
                getmediafilelocalstorage: {},
                alldata: {},
                currentYear: ''

            }

        }, 
        created(){

            //Set All Data
            this.alldata = JSON.parse(this.managealldata);

            //Localstorage Routine for Media List
            this.localStorageRoutine(this.getmediafilelocalstorage, this.mediafileslocalstorage, 'medialist', this.allmedia);

            //Localstorage Routine for Media List
            this.localStorageRoutine(this.getmediafilelocalstorage, this.mediafileslocalstorage, 'logotipolist', this.logotipomedia);

            //Instance Date
            let dataDate = new Date();

            //Get Current Year
            this.currentYear = dataDate.getFullYear();

        },
        mounted(){


        },
        methods:{

            localStorageRoutine(
                getmediafilelocalstorage, 
                mediafileslocalstorage, 
                indicatelocalstorage,
                allmedia
            ){

                //Get MediaList LocalStorage
                getmediafilelocalstorage = localStorage.getItem(indicatelocalstorage);

                //Check MediaList LocalStorage
                if(!getmediafilelocalstorage){

                    //Set MediaList on VueStore
                    mediafileslocalstorage = JSON.parse(allmedia);

                    //Set LocalStorage
                    localStorage.setItem(indicatelocalstorage, JSON.stringify(mediafileslocalstorage));

                }else{

                    //Remove LocalStorage
                    localStorage.removeItem(indicatelocalstorage);

                    //Set MediaList on VueStore
                    mediafileslocalstorage = JSON.parse(allmedia);

                    //Set LocalStorage
                    localStorage.setItem(indicatelocalstorage, JSON.stringify(mediafileslocalstorage));

                }

                //Clean Variables
                mediafileslocalstorage = {};
                getmediafilelocalstorage = {};

            }

        },
        computed:{

            computedGetMediaFileStorage(){

                return this.getmediafilelocalstorage;

            },
            computedMediaFileStorage(){

                return this.mediafileslocalstorage;

            }

        },
        watch:{

            computedGetMediaFileStorage(){},
            computedMediaFileStorage(){}

        },
        components:{

            tableElement: Table,

        }

    }

</script>